import {TwoWayBindable} from "@/types/TwoWayBindable";
import {Component, Emit} from "vue-property-decorator";

@Component({
    components: {},
})
export class ModalBase extends TwoWayBindable<boolean> {
    public get isModalVisible() {
        return this.value
    }

    public set isModalVisible(value: boolean) {
        this.input(value)
    }

    @Emit()
    close() {
        this.isModalVisible = false
        this.$store.dispatch('doUpdateIsInputChanged', true);
    }

    @Emit()
    cancel() {
        this.isModalVisible = false
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }

    @Emit()
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    input(value: boolean) {}
}
